import type { zhTW } from './zh-TW'

// 简体中文：所有 textKey 均已翻译（与 zh-TW 主词典 0 gap）。仍用 Partial 结构，
// 任何未来遗漏都会安全回退至 zh-TW，绝不漏出 raw key。
const zhCN: Partial<Record<keyof typeof zhTW, string>> = {
  'app.subtitle': 'JKBRα — 孤岛生存・每日挑战',
  'auth.guest': '访客游玩',
  'auth.login': '登录',
  'auth.register': '注册',
  'auth.back': '返回',
  'auth.handle.label': '账号代号',
  'auth.handle.ph': '3–20 字（英数、_、-）',
  'auth.name.label': '显示名称（可留空）',
  'auth.name.ph': '想让别人看到的名字',
  'auth.register.title': '创建账号',
  'auth.register.submit': '创建并进入',
  'auth.login.title': '登录账号',
  'auth.login.submit': '登录并进入',
  'auth.invalidHandle': '代号需 3–20 字，仅限英数、下划线、连字号。',
  'auth.password.label': '密码',
  'auth.password.ph': '至少 8 字，含字母与数字',
  'auth.pending': '处理中…',
  'auth.err.bad_password': '密码太弱：需至少 8 字、且含两种以上字符类型。',
  'auth.err.handle_taken': '此代号已被使用，请换一个。',
  'auth.err.bad_credentials': '代号或密码错误。',
  'auth.err.offline': '无法连接服务器，请稍后再试。',
  'rotate.title': '请竖握手机',
  'rotate.sub': '本游戏为竖屏设计，请将设备转回竖向以继续。',
  'app.loading': '加载资源中…',
  'app.loadError': '部分资源加载失败，请刷新页面后重试。',
  'boot.tap': '轻触开始',
  'boot.kbd': '键盘：方向键/WASD 移动・R/H 休息・E 逃脱・空格推进・数字键选择・Esc 返回',
  'boot.hint': '孤岛求生 · 最后幸存者获胜',
  'menu.story': '故事模式',
  'menu.freeplay': '自由对战',
  'menu.ranked': '排名',
  'menu.rankedOn': '🏅 排名模式：开（公平・无加成）',
  'menu.rankedOff': '🏅 排名模式：关（休闲）',
  'menu.settings': '设置',
  'menu.season': '赛季 Lv.{lv}（{into}/{next}）',
  'menu.loading': '加载账号中…',
  'menu.seasonCountdown': '赛季剩余 {days} 天',
  'menu.seasonEnded': '本赛季已结束',
  'menu.seasonUpcoming': '新赛季即将开始',
  'season.s1_tidefall': '「潮落」第一赛季',
  'season.unnamed': '本赛季',
  'menu.back': '返回',
  'menu.chapterSelect': '选择章节',
  'menu.chapterLocked': '🔒 完成前一章节后解锁',
  'menu.chaptersCleared': '已通关 {done}/{total} 章',
  'settings.title': '设置',
  'settings.pitch': '调整显示语言与游戏音效。设置会保存在此设备。',
  'settings.language': '语言 / Language',
  'settings.kbd': '［1–4］选择语言　［Esc］返回',
  'settings.current': '已是当前语言。',
  'settings.audio': '音效',
  'settings.soundOn': '开启',
  'settings.soundOff': '关闭',

  'hud.alive': '存活 {alive}/{total}',
  'hud.shrink': '距下次禁区扩张：{steps} 步',
  'hud.weather': '天候：{weather}',
  'hud.fogHint': '🌫 视野受限',
  'hud.hp': '生命',
  'hud.sp': '体力',
  'hud.kills': '击杀 {n}',
  'hud.key': '🔑 已夺得游戏解除钥匙',
  'explore.gotLoot': '＋物资',
  'explore.areaEnemies': '⚠ 此区敌踪 {n}',
  'explore.objective.title': '本局目标',
  'explore.objective.casual': '成为最后幸存者，或击败持钥者后按「逃脱」离岛。',
  'explore.objective.ranked': '每日同 seed 排位：击败 ghost 与 bot，结算后以公平规则登榜。',
  'explore.log.open': '记录',
  'explore.log.title': '行动记录',
  'explore.log.close': '关闭记录',
  'explore.intel.open': '情报',
  'explore.intel.close': '关闭情报',
  'explore.intel.enemies': '敌踪 {n}',
  'explore.intel.key': '钥匙持有者',
  'explore.intel.ghost': '玩家 ghost',
  'explore.intel.lore': '地点线索',
  'item.bandage': '绷带',
  'item.energy_drink': '能量饮料',
  'item.painkiller': '止痛药',
  'item.riceball': '饭团',
  'item.vest_frag': '防弹背心碎片',
  'item.radar': '雷达',
  'item.generic': '物资',
  'zone.unknown': '未知区域',
  'weapon.fists': '空手',
  'weapon.bat': '金属球棒',
  'weapon.machete': '柴刀',
  'weapon.saber': '军刀',
  'weapon.crossbow': '十字弓',
  'weapon.dart': '麻醉飞镖',
  'weapon.beretta': '贝瑞塔手枪',
  'weapon.uzi': 'Uzi 冲锋枪',
  'weapon.shotgun': '霰弹枪',
  'weapon.grenade': '手榴弹',
  'app.title': '大逃杀 α',
  'hud.danger': '⚠ 此区即将成为禁区，尽快离开！',
  'explore.kbd': '方向键/WASD 移动・R/H 休息・E 逃脱・Esc 退出',
  'explore.quit': '退出',
  'explore.quitConfirm': '放弃这场对战、返回主菜单？',
  'menu.gacha': '扭蛋',
  'menu.collection': '收藏',
  'menu.shop': '商城',
  'menu.progress': '通行证',
  'menu.hubToday': '今日战场',
  'menu.hubPitch': '单人入场，对抗自主 bot 与其他玩家留下的 ghost；每局结算推进角色、赛季与排行榜。',
  'menu.hubFooter': '目标：成为最后幸存者，或击败持钥者后逃脱。',
  'menu.story.badge': '教学 / 剧情',
  'menu.story.desc': '通过章节学会规则、缩圈、逃脱与角色故事。',
  'menu.story.meta': '首局推荐',
  'menu.survival': '生存挑战',
  'menu.survival.badge': '单人 Roguelite',
  'menu.survival.desc': '一局入岛、搜刮、战斗、拿魂解锁角色。',
  'menu.survival.meta': 'Casual',
  'menu.daily': '每日排位',
  'menu.daily.badge': 'Async PvP',
  'menu.daily.desc': '同日同 seed，遇到玩家 ghost，公平规则上榜。',
  'menu.daily.meta': 'Ranked',
  'menu.collection.sub': '出战角色 / 解锁',
  'menu.collection.ready': '可解锁 {n} 名角色',
  'menu.collection.next': '还差 {n} 魂解锁',
  'menu.collection.complete': 'Roster 已全解锁',
  'menu.progress.sub': '任务 / BP 奖励',
  'menu.shop.sub': '宝石 / 外观资源',
  'shop.title': '宝石商城',
  'shop.balance': '持有 💎 {gem}',
  'shop.bonus': '含红利 +{bonus}',
  'shop.confirm': '购买 💎 {gem}？将前往 Stripe 安全付款页完成付款。',
  'shop.redirecting': '前往安全付款页…',
  'shop.buy': '购买',
  'shop.success': '购买完成，💎 已入账。余额：{gem}',
  'shop.offline': '商城需要连线账号才能购买。请稍后再试。',
  'collection.title': '收藏',
  'collection.empty': '尚无收藏。去扭蛋抽抽看，把喜欢的角色与造型收进来吧！',
  'collection.offline': '收藏需要连线账号才能读取。请稍后再试。',
  'collection.equipped': '装备中',
  'collection.tapEquip': '点角色卡即可换上外观（不影响数值）',
  'collection.tapEquipShort': '点击装备外观',
  'collection.activeTitle': '出战角色',
  'collection.tapDeploy': '点角色卡选择出战（影响起手武器与被动）',
  'collection.deploying': '出战中',
  'collection.unlock.free': '初始',
  'collection.unlock.gacha': '扭蛋',
  'char.c_default.name': '预设战士',
  'char.c_kurotobi_nagi.name': '黑鸢 凪',
  'char.c_shiran_uta.name': '白兰 诗',
  'passive.none': '无被动',
  'passive.first_blood': '首杀：怒气 +50',
  'fail.noBoon': '没有可选的强化。',
  'log.boonOffer': '击杀对手！可选择一项强化。',
  'log.boonTaken': '强化生效：{name}。',
  'boon.title': '选择强化',
  'boon.generic': '强化',
  'boon.b_str.name': '猛攻',
  'boon.b_str.desc': '攻击 +6',
  'boon.b_guard.name': '坚守',
  'boon.b_guard.desc': '防御 +5',
  'boon.b_focus.name': '专注',
  'boon.b_focus.desc': '技巧 +5',
  'boon.b_plate.name': '护甲',
  'boon.b_plate.desc': '装甲 +4',
  'boon.b_vigor.name': '活力',
  'boon.b_vigor.desc': '最大体力 +30（立即回复）',
  'boon.b_endure.name': '耐力',
  'boon.b_endure.desc': '最大精力 +25（立即回复）',
  'collection.souls': '魂：{n}',
  'collection.unlockCost': '🔒 {n} 魂',
  'collection.cantAfford': '魂不足，无法解锁。多打几场累积魂。',
  'collection.gachaOnly': '扭蛋取得',
  'collection.gachaOnlyNote': '此角色需透过扭蛋取得（需连线账号）。',
  'result.souls': '+{n} 魂（共 {balance}）',
  'leaderboard.title': '排行榜',
  'leaderboard.pitch': '每日同 seed 排位：与玩家 ghost 竞速，公平规则上榜。',
  'leaderboard.open': '🏆 赛季排行榜',
  'leaderboard.season': '赛季：{id}',
  'leaderboard.empty': '本赛季尚无排名，快去打一场登榜！',
  'leaderboard.offline': '排行榜需要连线账号才能读取。请稍后再试。',
  'leaderboard.points': '{n} 分',
  'leaderboard.you': '你',
  'leaderboard.casual': '休闲',
  'leaderboard.ranked': '排名',
  'tier.bronze': '青铜',
  'tier.silver': '白银',
  'tier.gold': '黄金',
  'tier.platinum': '白金',
  'tier.diamond': '钻石',
  'tier.master': '大师',
  'leaderboard.me': '你的排名：第 {rank} 名（{points} 分）',
  'leaderboard.meNone': '你尚未登榜——完成一场对战即可上榜。',
  'gacha.title': '扭蛋',
  'gacha.titlePreview': '扭蛋（预览）',
  'gacha.pitch': '抽取角色与外观，扩充出战选择；排名模式仍维持公平规则，不出售战力优势。',
  'gacha.results.empty': '尚未抽取。十连会显示角色、外观与素材结果。',
  'gacha.pull10': '十连抽',
  'gacha.pull10Preview': '十连（预览）',
  'gacha.cost': '每次十连 {n} 钻',
  'gacha.pity': '距离保底 SSR：还需 {n} 抽',
  'gacha.pityReady': '下一抽必得 SSR！',
  'gacha.balance': '💎 {gem}　🪙 {coin}',
  'gacha.broke': '钻石不足，无法抽卡。',
  'gacha.offline': '服务器暂时无法连线，目前以预览模式显示，稍后再试。',
  'gacha.kbd': '［空格/Enter］抽卡　［Esc］返回',
  'gacha.ssr': 'SSR',
  'gacha.sr': 'SR',
  'gacha.r': 'R',
  'status.weapon': '武器：{w}',
  'combat.miss': '未命中',
  'combat.rage': '怒气',
  'combat.you': '你',
  'combat.kbd': '［空格］攻击　［S］必杀　［Esc］逃跑',
  'action.special': '必杀技！',
  'fail.noRage': '怒气不足，无法使出必杀技。',
  'fail.generic': '这个行动现在无法执行。',
  'log.special': '你蓄满怒气，使出浑身一击！',
  'log.serverState': '【服务器】存活 {alive}/{total}　·　第 {step} 步　·　名次 {rank}',

  'action.attack': '攻击 {name}',
  'action.attackWith': '攻击（{w}）',
  'action.escape': '逃脱',
  'action.flee': '逃跑',
  'rest.sleep': '睡眠（回体力）',
  'rest.heal': '治疗（回生命）',

  'fail.forbidden': '⚠ 该地已是禁区，项圈会引爆，无法前往。',
  'fail.sameZone': '你已经在此地，不需移动。',
  'fail.noSp': '体力不足，先休息一下吧。',
  'fail.deadAct': '你已经死亡，无法行动。',
  'fail.noKey': '你还没有游戏解除钥匙，无法逃脱。',
  'fail.notRunning': '比赛尚未开始。',

  'log.deploy': '你被投放到 {zone}。求生开始。',
  'log.move': '你移动到了 {zone}。',
  'log.search.nothing': '你仔细搜索，但什么也没找到。',
  'log.search.item': '你找到了 {item}！',
  'log.search.weapon': '你捡到了武器：{item}！',
  'log.pickup.serverManaged': '你看了看 {item}（连线对战：物资由服务器结算）。',
  'log.rest.sp': '你休息片刻，体力恢复了 {n}。',
  'log.rest.hp': '你包扎伤口，生命恢复了 {n}。',
  'log.rest.spFull': '你停下喘口气，但体力早已是满的。',
  'log.rest.hpFull': '你检视伤口，发现已无需包扎。',
  'log.encounter': '你在 {zone} 遇上了 {name}！',
  'log.ambush': '{name} 突然向你袭来！',
  'log.attackHit': '你对 {name} 造成 {dmg} 点伤害！',
  'log.attackMiss': '你的攻击落空了。',
  'log.counterHit': '{name} 反击，你受到 {dmg} 点伤害！',
  'log.injury': '{who} 的 {part} 部位受伤了！',
  'log.injurySelf': '你的 {part} 部位受伤了！',
  'log.crit': '会心一击！',
  'log.youKilled': '你击倒了 {name}！',
  'log.youDied': '你被 {name} 杀死了。',
  'log.botKill': '{killer} 杀死了 {victim}。',
  'log.collar': '{name} 留在禁区，项圈引爆身亡。',
  'log.broadcast': '【广播】下列地点即将成为禁区：{zones}。',
  'log.keyDrop': '你从 {name} 身上取得了 🔑 游戏解除钥匙！',
  'log.keyLost': '【广播】{name} 葬身禁区，🔑 游戏解除钥匙已转移至其他学员手中。',
  'log.enemyHit': '{name} 击中你，造成 {dmg} 点伤害！',
  'log.enemyMiss': '{name} 的攻击落空了。',
  'log.hazard': '荒野的危险使你损失了 {n} 点生命。',
  'log.youDiedEnv': '你伤重不支，倒了下去……',
  'log.fled': '你脱离了战斗。',
  'log.targetGone': '对方已经不在这里了。',
  'log.actionFailed': '操作失败，请再试一次。',

  'part.b': '胸',
  'part.h': '头',
  'part.a': '腕',
  'part.f': '足',
  'arch.player': '你',
  'arch.hunter': '猎杀型',
  'arch.survivor': '苟活型',
  'arch.looter': '拾荒型',
  'arch.veteran': '老兵型',
  'arch.medic': '结盟型',
  'arch.boss': '监督教官',

  'weather.w0': '晴天',
  'weather.w1': '大晴',
  'weather.w2': '多云',
  'weather.w3': '小雨',
  'weather.w4': '暴雨',
  'weather.w5': '台风',
  'weather.w6': '雷雨',
  'weather.w7': '下雪',
  'weather.w8': '起雾',
  'weather.w9': '浓雾',
  'weather.unknown': '天候不明',

  'result.win.survivor': '最后幸存',
  'result.win.escape': '成功逃脱孤岛',
  'result.lose': '你已出局',
  'result.rank': '名次：{rank} / {total}',
  'result.kills': '击杀数：{n}',
  'result.survived': '存活步数：{n}',
  'result.rewards': '结算奖励',
  'result.nextTitle': '下一步',
  'result.nextCollection': '用魂解锁出战角色，下一局带新起手武器与被动入场。',
  'result.nextUnlockReady': '已有足够魂解锁 {n} 名角色；进收藏换新起手武器与被动。',
  'result.nextUnlockSoon': '还差 {n} 魂可解锁下一名角色；再打一局就有明确目标。',
  'result.nextUnlockComplete': '出战角色已全解锁；改冲赛季通行证与排行榜。',
  'result.gainCoin': '金币 +{n}',
  'result.gainXp': '赛季经验 +{n}',
  'result.levelUp': '赛季等级提升：Lv.{from} → Lv.{to}',
  'result.seasonLv': '赛季等级 Lv.{lv}',
  'result.missionDone': '完成每日任务：{name}',
  'result.settleOffline': '（结算未连线，稍后再同步）',
  'mission.play_1': '出战一场',
  'mission.kill_3': '击倒 3 名对手',
  'mission.survive_20': '存活 20 步',
  'mission.generic': '每日挑战',
  'progress.title': '赛季进度',
  'progress.daily': '每日任务',
  'progress.mission': '{name}　{cur}/{goal}',
  'progress.reward': '・奖 金币{coin}/经验{xp}',
  'progress.offline': '进度需连线（?backend=1 并启动服务器）。',
  'bp.title': '赛季通行证',
  'bp.claimable': '可领取 {n} 项',
  'bp.claim': '领取奖励',
  'bp.none': '目前没有可领取的奖励',
  'bp.gained': '已领取：金币 +{coin}、道具 ×{items}',
  'bp.hint': '赛季通行证有 {n} 项可领取（点此前往领取）',
  'bp.track': '通行证轨道　已领 {claimed}/{total} 级',
  'gacha.pulling': '抽取中…',
  'gacha.confirm.q': '确认消耗 {n} 💎进行十连抽？（余额 {bal} 💎）',
  'gacha.confirm.yes': '确认抽取',
  'gacha.confirm.no': '取消',
  'gacha.confirm.pity': '本次必出 SSR！',
  'gacha.loading': '加载中…',
  'result.settling': '结算中…',
  'bp.claiming': '领取中…',
  'bp.levelLine': 'Lv.{lv}　金币 {coin}{item}',
  'bp.kind.skin': '＋造型',
  'bp.kind.material': '＋碎片',
  'bp.kind.char': '＋角色',
  'bp.kind.other': '＋道具',
  'result.again': '再玩一局',
  'result.toCollection': '角色解锁',
  'result.toPass': '通行证',
  'result.toMenu': '回主菜单',
  'result.kbd': '［Enter］再玩一场　［Esc］回主菜单',
  'result.l-survivor': '你撑到了最后，成为唯一的幸存者。',
  'result.l-escape': '你夺得钥匙、逃离孤岛，挣脱了这场游戏。',
  'result.l-dead': '游戏仍在继续，但你的故事在此画下句点。',

  'zone.north_peak.name': '北山顶',
  'zone.cliff.name': '断崖',
  'zone.lighthouse.name': '灯塔',
  'zone.north_temple.name': '北寺（佛堂）',
  'zone.north_knoll.name': '北丘',
  'zone.central_pond.name': '中央池',
  'zone.west_pond.name': '西池',
  'zone.tourism.name': '观光协会大楼',
  'zone.houses_north.name': '民家聚落（北）',
  'zone.clinic.name': '医疗诊所',
  'zone.school.name': '学校（常时禁区）',
  'zone.thicket.name': '杂木林',
  'zone.shrine.name': '神社',
  'zone.farm_assoc.name': '农协大楼',
  'zone.fish_assoc.name': '渔协大楼',
  'zone.south_peak.name': '南山顶',
  'zone.south_temple.name': '南寺',
  'zone.reservoir.name': '贮水池（水坝）',
  'zone.port.name': '港口',
  'zone.north_peak.desc': '岛屿北部的制高点，视野开阔，能俯瞰整片海域与半座岛。',
  // ── Zone lore（北部聚落，分批补译；其余区域仍回退 zh-TW）──
  'zone.north_peak.lore': '站上山顶虽能掌握敌踪，却也让自己无所遁形。',
  'zone.cliff.lore': '走投无路的人，有的选择从这里纵身一跃。',
  'zone.lighthouse.lore': '一群人曾在此据守，却因猜疑与一包毒药，演成同伴互相残杀的枪战。',
  'zone.north_temple.lore': '入夜之后，这里令人毛骨悚然。',
  'zone.north_knoll.lore': '起伏的地形适合伏击，也适合被伏击。',
  'zone.central_pond.lore': '与其说是池，不如说是沼泽，令人不安。',
  'zone.west_pond.lore': '想找水源的人会来，但这里太安静了。',
  'zone.tourism.lore': '有人曾在此架起电脑，企图黑入主办方的系统、终结这场游戏。',
  'zone.houses_north.lore': '居民早被强制撤离，只剩躲藏者压抑的呼吸。',
  'zone.clinic.lore': '受伤的人都想来，于是这里也最危险。',
  'zone.school.lore': '此处为「常时禁区」，踏入即引爆项圈——监督教官就在里面看着你们。',
  'zone.thicket.lore': '在林中遇袭，往往连防备都来不及——这里是冷血猎人的狩场。',
  'zone.shrine.lore': '不知名的神，被遗忘地祭祀着。',
  'zone.farm_assoc.lore': '镰刀与锄头，在这座岛上都成了凶器。',
  'zone.fish_assoc.lore': '从窗口能望见港口——以及那艘等着优胜者的船。',
  'zone.south_peak.lore': '易守难攻，适合负隅顽抗。',
  'zone.south_temple.lore': '白日尚可，入夜后这里格外瘆人。',
  'zone.reservoir.lore': '开阔的水畔无处藏身，却是必经的水源。',
  'zone.port.lore': '这是士兵与优胜者离岛的唯一出口。',
  'zone.beach.lore': '向大海望去，只有四处巡弋的船，提醒你无处可逃。',
  'zone.houses_south.lore': '想找补给就得快——别人也是这么想的。',
  'zone.cliff.desc': '临海的陡峭断崖，海风呼啸，脚下是拍打礁石的浪。',
  'zone.lighthouse.desc': '矗立在东岸的白色灯塔，是岛上最显眼的地标。',
  'zone.north_temple.desc': '北部山腰的佛寺，香火早断，佛像在阴影中静默。',
  'zone.north_knoll.desc': '长满芒草的小丘，风一吹便沙沙作响。',
  'zone.central_pond.desc': '岛中央的池塘，水面映着天光，四周芦苇丛生。',
  'zone.west_pond.desc': '西侧的小池，水色暗绿，岸边泥泞难行。',
  'zone.tourism.desc': '废弃的冲木岛观光协会办公楼，桌上还有褪色的观光手册。',
  'zone.houses_north.desc': '北侧的住宅区，门户洞开，餐桌上的饭菜早已冷掉。',
  'zone.clinic.desc': '岛上唯一的诊所，药柜多半已空，消毒水味残留。',
  'zone.school.desc': '你们被投放的学校，如今是主办方的本部；一靠近，项圈便哔哔作响。',
  'zone.thicket.desc': '茂密的杂木林，枝叶遮天，视线不过数步之遥。',
  'zone.shrine.desc': '南部的神社，鸟居斑驳，石阶爬满青苔。',
  'zone.farm_assoc.desc': '农业协会的仓库大楼，堆着生锈的农具与成袋化肥。',
  'zone.fish_assoc.desc': '渔业协会的建筑，弥漫海腥味，墙上挂着破旧渔网。',
  'zone.south_peak.desc': '南部的山头，怪石嶙峋，视野不如北山开阔。',
  'zone.south_temple.desc': '南部的寺院，殿宇荒废，蛛网密布。',
  'zone.reservoir.desc': '供应全岛的贮水池与小型水坝，水声在寂静中格外清晰。',
  'zone.port.desc': '岛南的港口，数艘船停泊着，缆绳在风中摇晃。',
  'zone.beach.desc': '南岸的沙滩，海浪一波波拍上岸，远处是巡逻的监视船。',
  'zone.houses_south.desc': '南侧的住宅街，商店比别处多，货架却早被搬空。',
  'zone.beach.name': '沙滩',
  'zone.houses_south.name': '民家聚落（南）',

  'story.tap': '▶ 轻触继续',
  'story.kbd': '［空格/Enter］继续　［1–3］选择　［Esc］返回',
  'story.enterMatch': '⚔ 进入战场',
  'story.complete': '本章完结',
  'story.allComplete': '～ 全篇完结 ～',
  'story.toMenu': '回主菜单',
  'story.broken': '这个章节暂时无法进行，请返回主菜单再试一次。',

  's.char.you': '你',
  's.char.sakura': '立花 樱',
  's.char.rin': '黑泽 凛',
  's.char.kaede': '一之濑 枫',
  's.char.hikari': '望月 光',
  's.char.officer': '监督教官',
  's.char.voice': '广播',

  's.prologue.title': '序章：开始',
  's.ch1.title': '第一章：初夜',
  's.ch2.title': '第二章：信任与背叛',
  's.ch3.title': '第三章：观光协会的信号',
  's.ch4.title': '第四章：猎杀者',
  's.ch5.title': '第五章：项圈的秘密',
  's.ch6.title': '终章：黎明',

  // 章节简介
  's.prologue.sum': '一场校外教学，在一阵瓦斯后变了调。你在陌生的岛上醒来，脖子上多了一个冰冷的项圈。',
  's.ch1.sum': '夜幕降临孤岛。第一声广播响起，禁区开始扩张。你必须在恐惧与信任之间，做出第一个选择。',
  's.ch2.sum': '结盟能让你活得更久，也可能让你死得更惨。当补给见底，谁还会站在你这边？',
  's.ch3.sum': '枫在废弃的观光协会大楼里，找到了或许能瘫痪主办方系统的方法——但时间正在流逝。',
  's.ch4.sum': '凛不再躲藏。她以冷静而精准的方式，一个接一个地清除名单上的人。下一个，会是你吗？',
  's.ch5.sum': '逃离这座岛的唯一办法，藏在每个人脖子上的项圈里。代价，是有人必须冒死一试。',
  's.ch6.sum': '当天色将明，岛上只剩下寥寥数人。你选择成为幸存者、逃脱者，还是掀桌反抗的人？',

  // 序章
  's.prologue.s1.1': '校外教学的巴士在山路上行驶，窗外的绿意一闪而过。你昏昏欲睡。',
  's.prologue.s1.2': '一股甜腻的气味悄悄渗进车厢。同学一个接一个垂下了头。',
  's.prologue.s1.mid': '你伸手想推醒邻座的同学，指尖却越来越沉。最后映入眼底的，是司机座位后方那面——不知何时，已被人从外侧上了锁的隔板。',
  's.prologue.s1.3': '你想喊出声，喉咙却发不出声音。眼前一黑——',
  's.prologue.s2.1': '冰冷的地面。刺眼的日光灯。你在一间陌生的教室里醒来。',
  's.prologue.s2.wake': '你下意识数着身边倒卧的同学，数字越数越乱。指尖摸到颈间——一圈冰冷的金属，不知何时已扣上。那一刻你才真正清醒：这不是恶梦，醒来，才是恶梦的开始。',
  's.prologue.s2.officer': '「都醒了？很好。欢迎来到本届『计划』的会场。」',
  's.prologue.s2.officer2': '他翻开手中的板夹，语气像在念一份再普通不过的行程表：「报到、适应、淘汰——流程都印在你们座位底下的手册里。对了，逃生门已经焊死了。那是上一届的人，教会我们的。」',
  's.prologue.s2.2': '你伸手摸向脖子——一圈金属冰冷地箍着，无论如何都解不开。',
  's.prologue.s2.sakura': '「别……别乱动那个东西！教官说，硬拆会爆炸的……」',
  's.prologue.s2.after': '你缓缓把手放下。那女孩的声音在发抖，却仍硬撑着想安抚别人——你记住了她的眼神，也记住了自己掌心的冷汗。',
  's.prologue.s3.officer1': '「规则很简单：你们要互相残杀，直到只剩一人。那个人，就能活着离开。」',
  's.prologue.s3.officer2': '「岛上会逐步划出『禁区』。时间一到还待在禁区里，项圈就会替你倒数。」',
  's.prologue.s3.officer3': '「每人发一份补给、一件武器——运气好坏，自己认了。游戏，现在开始。」',
  's.prologue.s3.after': '教室里先是一片死寂，接着压抑的啜泣、翻倒的椅子、有人冲向门口又被一道无形的界线逼了回来。监督教官只是抱着手，像在看一场早已预演过无数次的戏。倒数，已经开始。',
  's.prologue.s4.q': '坐在你旁边的同学忽然站起来嘶吼。你——',
  's.prologue.s4.cA': '保持冷静，先观察情势',
  's.prologue.s4.cB': '质问教官这一切的意义',
  's.prologue.s4.rA': '你压下颤抖，冷静地环顾四周。活下去，得先看清楚规则。',
  's.prologue.s4.rA.after': '你不动声色地记下几件事：监督教官腰间的遥控器、门边穿黑衣的看守、墙上那台始终亮着红灯的摄影机。情绪帮不了你，但这些细节，也许可以。',
  's.prologue.s4.rB': '「为什么要这么做？」你质问。',
  's.prologue.s4.rB.officer': '教官只是笑了笑：「问为什么的人，通常活不久。」',
  's.prologue.s4.rB.after': '他的目光在你脸上多停了一秒，像替你的编号做了个记号。周围的同学悄悄挪远半步——在这座岛上，出头的钉子，往往最先被敲下去。你把不甘咽回喉咙，记住了：有些问题，只能用活着去回答。',
  's.prologue.s4.cC': '安抚身旁失控的同学',
  's.prologue.s4.rC': '你伸手按住那名同学颤抖的肩膀，压低声音说了句什么。',
  's.prologue.s4.rC.after': '嘶吼渐渐化为粗重的喘息，整间教室紧绷的空气，似乎也松了那么一线。监督教官瞥了你一眼，没有作声。你忽然明白：在这里，连一点点镇定都是一种抵抗——而人们会记得，是谁先伸出了手。',
  's.prologue.s5.1': '人群被赶出校门，分散投放到岛上各处。海风吹来，夜色正浓。',
  's.prologue.s5.sakura': '「等等！是你啊……太好了。我们……一起行动，好吗？」立花樱向你伸出手。',
  's.prologue.s5.q': '你——',
  's.prologue.s5.cA': '与樱同行',
  's.prologue.s5.cB': '婉拒，独自行动',
  's.prologue.s5.rA': '你握住了那只颤抖的手。至少现在，你不是一个人。',
  's.prologue.s5.rA.sakura': '「……谢谢。」さくら破涕为笑，回握住你的手，「不管接下来会怎样，我们都一起面对。」',
  's.prologue.s5.rA.end': '两道身影并肩没入夜色。游戏才刚开始——但至少这一夜，有人与你共数彼此的呼吸。',
  's.prologue.s5.rB': '「抱歉……一个人比较安全。」你转身没入黑暗，背后传来她轻轻的一声叹息。',
  's.prologue.s5.rB.mid': '你没有回头。在这座岛上，心软与迟疑，往往比刀刃更早要人的命——你这样告诉自己，把那声叹息，连同心里某种更柔软的东西，一起留在了身后。',
  's.prologue.s5.rB.end': '黑暗很快吞没了那声叹息。你独自前行，脚步声成了这座岛上唯一肯回应你的东西。',
  's.prologue.s5.cC': '同行，但先把规矩说清',
  's.prologue.s5.rC': '「可以一起走。」你顿了顿，「但先说好——谁想走，随时都能走，不欠谁。」',
  's.prologue.s5.rC.sakura': '「……嗯，这样很好。」さくら收回手，郑重地点头，「不勉强，也不背叛。这是我们的第一个约定。」',
  's.prologue.s5.rC.end': '没有誓言，只有一条谁都能松开的绳。但正因为松得开，这一夜你们反而走得格外安稳。',

  // 第一章
  's.ch1.s1.scene': '入夜后，你被推进这座岛的黑暗里。手中只有一张粗糙的地图、一支电筒，和一件被硬塞来的武器。校舍的轮廓在远处黑成一块剪影，同学们各自散入夜色——很快，你连他们的脚步声都听不见了。',
  's.ch1.s1.voice': '【广播】各位同学晚安。以下地点即将成为禁区，请尽速离开……',
  's.ch1.s1.1': '冰冷机械的广播在岛上每个角落回荡。求生的倒数，开始了。',
  's.ch1.s1.mid': '广播的语气客气得近乎温柔，反而更教人发寒。你告诉自己：一起上过课的人，不可能真的对彼此举刀。然而黑暗里渐近的脚步声，正一步步把这份天真，从你身上剥下来。',
  's.ch1.s2.1': '黑暗中，一个身影踉跄地朝你冲来，手里握着什么东西反着光——是望月光，她哭着。',
  's.ch1.s2.hikari': '「对不起、对不起……我不想死！只要解决掉你，我就……！」',
  's.ch1.s2.q': '她挥刀扑上。你——',
  's.ch1.s2.cA': '夺下她的刀、制止她',
  's.ch1.s2.cB': '本能地反击',
  's.ch1.s2.cC': '转身就跑',
  's.ch1.s2.rA': '你扣住她的手腕，刀落在地。她瘫坐下来，崩溃大哭。你救了一个人——也留下了一个变数。',
  's.ch1.s2.rA.hikari': '「为什么……为什么不还手？」ひかり抬起泪脸，声音抖得不成样，「我差点就杀了你。可你却……谢谢你，把我从那个我自己手里，拉了回来。」',
  's.ch1.s2.rA.after': '你扶她起身，掌心触到她仍在发抖的手。你说不清这一刻救下的，是她，还是自己心里某个还不肯认输的部分。但你知道：只要还愿意伸出手，你就还没被这座岛，真正变成它要的样子。',
  's.ch1.s2.rB': '你的身体比脑袋更快。等回过神，她已经倒在血泊里，眼里还凝着恐惧。你杀了第一个人。',
  's.ch1.s2.rB.after': '手还在抖，掌心的温度却怎么也散不掉。你想吐，想跪下道歉，想假装这不是真的——可岛不给你时间。你逼自己站直，把那声「对不起」咽回喉咙：记住这份重量，但别让它现在就压垮你。活下去，才有资格忏悔。',
  's.ch1.s2.rC': '你拔腿狂奔，把哭喊声抛在身后。逃避不可耻——但岛会缩小，总有一天无处可逃。',
  's.ch1.s2.rC.after': '跑出很远，那道哭声却像钉在耳膜上。你没有杀她，也没有救她——只是把选择推给了下一个遇见她的人。你说不清这算不算更干净，只知道自己的手心，同样全是冷汗。',
  's.ch1.s3.1': '你躲进一栋废屋喘息。角落里，一个冷静的声音响起。',
  's.ch1.s3.kaede': '「别紧张，我没带武器。我是一之濑枫。我在想——这项圈，这系统，一定有破绽。」',
  's.ch1.s3.2': '她摊开一张岛的草图，指向东边的观光协会大楼。',
  's.ch1.s3.kaede2': '「那里有电脑和线路。给我时间，也许我能让所有项圈一起失效。你，愿意赌一把吗？」',
  's.ch1.s3.cA': '「赌。我信你说的那个破绽。」',
  's.ch1.s3.cB': '「赌，但我会替自己留一条退路。」',
  's.ch1.s3.cC': '「我不赌系统，只赌自己活着走出去。」',
  's.ch1.s3.rA': '你没有犹豫。楓怔了一下，随即弯起眼睛。',
  's.ch1.s3.rA.kaede': '「……谢谢。被人毫无保留地信任，是会让人想拼命的。给我三天——不，给我到下一次缩圈之前。」',
  's.ch1.s3.rB': '你答应了，但话说得很有分寸。楓不但不介意，反而点了点头。',
  's.ch1.s3.rB.kaede': '「聪明。把命押在别人没验证过的计划上，本来就是蠢事。留好退路——然后，尽量别用上它。」',
  's.ch1.s3.rC': '你把话说得很白。楓沉默了半晌，没有反驳。',
  's.ch1.s3.rC.kaede': '「也对。我没资格要你拿命陪我赌。那就各走各的——但若你改变主意，观光协会大楼，我等你。」',
  's.ch1.s4.1': '窗外掠过一道沉着的身影。是黑泽凛，班上最冷静的人——此刻，她手里有枪。',
  's.ch1.s4.rin': '「枫的计划？很美。但在它成功之前，我会先把名单清干净。包括你们。」',
  's.ch1.s4.2': '她没有开枪，只是留下一句话，便消失在夜色里。威胁，已经成形。',
  's.ch1.s4.after': '凛的脚步声被夜色吞没，那句话却黏在你背上久久不散。你这才明白：在这座岛上，最危险的从来不是呐喊着扑上来的人，而是早已算好你几时该死、再从容扣下扳机的人。',
  's.ch1.s5.1': '夜还很长。禁区仍在扩张，而你，必须走进这座岛，活下去。',
  's.ch1.s5.sakura': '「我不会照他们写好的剧本死去。哪怕只剩我一个人记得大家的名字——我也要把它带出这座岛。」',
  's.ch1.s5.2': '立花さくら攥紧了掌心里那枚冰冷的编号牌。恐惧还在，但它第一次有了形状——一个她决定要打碎的形状。',
  's.ch1.s5.end': '海风卷起远处的广播杂讯，像在催促。さくら朝你点了点头——没有退路的第一步，就从现在迈出。',

  // 第二章
  's.ch2.s1.scene': '岛屿的时间以「广播点名」切割——每隔几小时，冰冷的女声念出新增的死者编号，名单一截截变短。你学会在通报的空档里移动、在通报的瞬间屏息，把日子过成一种数字的退潮。',
  's.ch2.s1.voice': '【广播】定时点名。新增除名编号——零四、一七、二二、三十。名单，又短了一截。愿幸存者，活得比愧疚更久。',
  's.ch2.s1.1': '两天过去，背包里的干粮见了底。你躲进一间民家，借着月光清点所剩无几的补给。',
  's.ch2.s1.mid': '饥饿会放大每一个声响，也放大每一分怀疑。你忽然明白：在这座岛上最先见底的，从来不是干粮，而是「能不能相信一个人」的余裕。',
  's.ch2.s1.2': '门外传来脚步声。你屏住呼吸——是枫，她脸色凝重。',
  's.ch2.s2.kaede': '「有人在岛上散播假情报，故意把同学引进禁区。再这样下去，名单会空得比谁动手都快。」',
  's.ch2.s2.q': '枫要你帮忙拆穿那个造谣者。但她的消息，你又该全信吗？',
  's.ch2.s2.cA': '相信枫，照她的计划走',
  's.ch2.s2.cB': '留一手，自己查证',
  's.ch2.s2.rA': '你点头。能在这座岛上还愿意拆穿谎言的人，本身就值得赌一把。',
  's.ch2.s2.rA.kaede': '枫怔了一下，似乎没料到你答得这么干脆。她别过头，声音比平时低了些：「……谢了。在这里，肯把后背交给别人的人不多了。我不会让你后悔的——这一次，我说到做到。」',
  's.ch2.s2.rA.after': '你不确定枫的情报有几分真，但你更清楚：若连愿意拆穿谎言的人都不肯信，这座岛就真的只剩谎言了。把后背交出去是一场赌注——而你选择先赌一个，还愿意说真话的人。',
  's.ch2.s2.rB.before': '你摇了摇头，没有立刻接下她的计划。情报可以参考，但得由你自己的眼睛确认过，才算数。',
  's.ch2.s2.rB': '「我自己确认过再说。」枫没有生气，只是淡淡地说。',
  's.ch2.s2.rB.kaede': '「谨慎是对的——只要别谨慎到没有人可信。」',
  's.ch2.s2.cC': '表面答应，暗中留一手',
  's.ch2.s2.rC': '你点了头，笑得恰到好处——心里却把退路与疑点一一记下。结盟是真的，提防也是真的。',
  's.ch2.s2.rC.kaede': '枫看了你一眼，像是看穿了什么，却只是轻轻笑了：「这样也好。在这座岛上，太快全心信人的，往往活不久。」',
  's.ch2.s2.rC.after': '你笑着应和，心底却有个角落悄悄凉了下去。在这座岛上活下来的代价，或许就是再也无法毫无保留地，把后背交给任何人——包括，总有一天，连你都会开始怀疑自己。',
  's.ch2.s2.rB.after': '枫没有多留，转身没入暗处前丢下一句：「查吧。等你确认完，我会在诊所后门等你——如果那时你还愿意来。」她的背影里，没有责怪，只有一种被反复辜负后仍选择等待的疲惫。',
  's.ch2.s3.1': '循线追查，你们在诊所堵到了造谣者。没想到，竟是看似最人畜无害的那个转学生。',
  's.ch2.s3.2': '他笑着举起手中的无线电：「我只是想活下去而已……难道你们不是吗？」枪口，已经对准了你。',
  's.ch2.s3.kaede': '枫挡到你身前半步，声音冷得像刀：「被假情报害死的人，不会因为你『只是想活下去』就回得来。把无线电放下——这是我最后一次好好说话。」',
  's.ch2.s3.cA': '放下武器，给他一条活路。',
  's.ch2.s3.cB': '不退，但只要他肯放下无线电。',
  's.ch2.s3.cC': '这种人留着，就是下一个被害者的伏笔。',
  's.ch2.s3.rA': '你缓缓垂下武器。那一瞬，他眼底闪过一丝动摇——可无线电「咔」地响了一声，选择权已不在你手上。',
  's.ch2.s3.rA.kaede': '枫轻声说：「你比我善良。但愿这座岛，没把这份善良变成你的弱点。」',
  's.ch2.s3.rB': '你没有退，枪口却没有抬高半分。「放下它，你还能走。」你说。他的手指，仍在扳机上收紧。',
  's.ch2.s3.rB.kaede': '枫站在你身侧，没有劝阻，只低声补了一句：「机会给过了。接下来，不是你的错。」',
  's.ch2.s3.rC': '你做了最冷的判断。话还没说完，动作已经先出。',
  's.ch2.s3.rC.kaede': '枫没有拦你。她只是看了你一眼，像把这一刻，悄悄记进了某份只有她看得见的名单。',
  's.ch2.s4.1': '谎言被拆穿，真正的厮杀也随之而来。你握紧武器，迎向这座岛的恶意。',
  's.ch2.s4.sakura': '「『我只是想活下去』——大家都这么说。可是さくら不准这句话，变成伤害别人的借口。」',
  's.ch2.s4.end': '对方的无线电还在沙沙作响，仿佛替这座岛清点今夜的名单。さくら退到你身侧，不再多言——剩下的话，只能交给接下来的每一步去回答。',

  // 第三章
  's.ch3.s1.scene': '观光协会大楼踞在岛屿东缘，落地窗外，港口的吊灯在夜里明明灭灭，远处灯塔的光每隔几秒划过海面。再往内陆，学校的讯号塔像一根冰冷的针，扎进这座岛的心脏。',
  's.ch3.s1.kaede': '「就是这里。」枫在观光协会大楼的机房前蹲下，指尖在键盘上翻飞。「主办方的讯号塔就在学校，我能从这里反向干扰。」',
  's.ch3.s1.kaede2': '她没有回头，只低声补了一句：「我不擅长打架。可是要让那些躲在屏幕后面的人，尝尝被盯上的滋味——这个，我很擅长。」',
  's.ch3.s1.1': '萤幕上的进度条缓慢爬升。她需要时间——而时间，是这座岛最奢侈的东西。',
  's.ch3.s1.voice': '【广播】各位同学，午夜通报。存活人数——十一。较昨夜，少了七。请珍惜彼此剩下的相处时光。',
  's.ch3.s1.mid': '你盯着那条一格一格爬升的进度条，忽然觉得荒谬又心酸——在这座把人逼成野兽的岛上，他们的希望，竟被缩小成一行还没跑完的代码。而你愿意，替这行代码挡下所有子弹。',
  's.ch3.s2.q': '远处传来脚步与枪声，正在逼近。你要——',
  's.ch3.s2.cA': '守在门口，替枫挡下来人',
  's.ch3.s2.cB': '催枫加速，冒着烧坏机器的风险',
  's.ch3.s2.rA': '你堵在门口，像一道墙。「快点，我挡得住——大概吧。」',
  's.ch3.s2.rA.kaede': '枫头也没抬，手指在面板上翻飞，声音却软了一瞬：「……别逞强。听到不对劲就退，我不需要用你的命换来的那几秒。」她顿了顿，「但——谢谢。这扇门，我就交给你了。」',
  's.ch3.s2.rB': '「跳过校验、直接灌！」枫咬牙照做，机器发出刺耳的嗡鸣，火花四溅。',
  's.ch3.s2.rB.after': '指示灯一路飙红，外壳烫得能煎蛋。「撑住……再三十秒就好——」话没说完，一声闷响，半边面板黑了。枫咬牙切到备援：「还能跑，但只剩一次机会。别让我白烧这台。」',
  's.ch3.s2.cC': '声东击西，把来人引去别处',
  's.ch3.s2.rC': '你抄起一截钢管砸向走廊另一头的铁柜，巨响在空楼里炸开。脚步声一窝蜂追着回音而去——你替枫，硬生生偷来了几分钟。',
  's.ch3.s2.rC.kaede': '「……你这人，脑袋转得比我还快。」枫忍不住笑了一下，指尖却没停，「行，剩下的交给我——别走远，回声骗得了一时。」',
  's.ch3.s3.kaede': '「再给我三分钟……不，两分钟！」枫的额头渗出汗。',
  's.ch3.s3.bar': '进度条，停在了百分之九十。',
  's.ch3.s3.sakura': '「枫，看着我，别看进度条。」さくら的声音压得很稳，「你只管把讯号送出去，剩下的归我。我们是一起进来的，就要一起出去。」',
  's.ch3.s3.kaede2': '「……嗯。」枫深吸一口气，指尖不再发抖，「谢谢你，さくら。有你在，我好像就真的能做到。」',
  's.ch3.s3.beat': '那一瞬，仓库里仿佛只剩两道呼吸，与一行缓缓爬升的数字。你忽然很想守住这一刻——守住这座岛上，难得还没被恐惧吃掉的东西。',
  's.ch3.s3.1': '就在此时，门被踹开。讯号还没送出，敌人已经到了。',
  's.ch3.s4.kaede': '「百分之九十不是零。帮我挡住他们——把最后两分钟，交到我手上。」枫的指尖没有一刻停下。',
  's.ch3.s4.cA': '死守门口，一个都别想进来。',
  's.ch3.s4.cB': '主动迎上去，把他们引离枫。',
  's.ch3.s4.cC': '把备用武器塞给さくら，并肩挡。',
  's.ch3.s4.rA': '你横身堵在唯一的入口，把整条走廊变成只能一个一个过的窄门。',
  's.ch3.s4.rA.kaede': '「好位置。」枫头也没抬，「他们一次只能来一个——这两分钟，我守得住数字，你守得住门。」',
  's.ch3.s4.rB': '你没有等他们进来，反而欺身冲出，把厮杀引向远离仓库的那一侧。',
  's.ch3.s4.rB.kaede': '「喂——！」枫一惊，随即明白了你的用意，咬牙把视线逼回屏幕，「……活着回来。听见没有。」',
  's.ch3.s4.rC': '你反手把备用武器抛给さくら。她稳稳接住，与你背靠背站定。',
  's.ch3.s4.rC.sakura': '「一起进来的，就一起挡。」さくら与你背贴着背，「枫只管数她的数字——这道门，有我们两个。」',
  's.ch3.s4.1': '计划成败，全看接下来这一战。你深吸一口气，迎了上去。',
  's.ch3.s4.end': '屏幕的进度条一格一格往上爬，像在跟死亡赛跑。你把枫和那两分钟护在身后——这座岛想要的答案，你打算用拳头写给它。',

  // 第四章
  's.ch4.s1.scene': '夜更深了。浓雾自低洼处漫起，吞掉树干、吞掉声音，连自己的呼吸都显得突兀。林子里每一步落叶都像踩在别人的神经上——你开始懂得，真正的猎人不会出声，他们只是等。',
  's.ch4.s1.voice': '【广播】禁区扩张通知。北部林线即将封锁，雾中行动者请特别留意——能见度，从来不会站在猎物这一边。',
  's.ch4.s1.1': '杂木林的雾气里，一个身影静静地站着，彷彿已经等了你很久。是凛。',
  's.ch4.s1.rin': '「枫的讯号，差一点就成了。可惜，差一点就是差很多。」她抬起枪，「在系统被关掉之前，我会先把你们关掉。」',
  's.ch4.s1.mid': '她的枪口很稳，稳得不像在泄愤，而像在执行一个早已算清代价的决定。你忽然懂了——凛不是享受猎杀，她只是抢先替所有人，把「下手」的罪一个人扛了。',
  's.ch4.s2.q': '她的指尖搭上扳机。你——',
  's.ch4.s2.cA': '正面迎战，赌一个你死我活',
  's.ch4.s2.cB': '试着说服她加入',
  's.ch4.s2.cC': '利用雾气脱离',
  's.ch4.s2.rA': '「那就来吧。」你举起武器。既然退无可退，就只剩向前。',
  's.ch4.s2.rA.rin': '「好。」凛的唇角扬起极浅的弧——那不是笑，是猎人遇上值得出手的对手时的专注，「至少你不打算跪着死。这份胆子撑不过三招，但我会记得你曾经有过。」',
  's.ch4.s2.rA.after': '你听出那句话底下的东西——她不是看轻你，是早替自己预习过无数次「对手的死法」。握紧武器的瞬间，你忽然不再怕输：能逼黑泽凛认真出手，至少证明你还没被这座岛磨成一个数字。三招？那就让她数到第四招。',
  's.ch4.s2.rB': '「你比谁都清楚这场游戏有多荒谬——何不一起掀了它？」凛沉默了半秒，那半秒，或许就是裂缝。',
  's.ch4.s2.rB.rin': '「……一起？」她别开视线，枪口却悄悄垂下几分，「如果我信了你，到头来却没成——那些因为我犹豫而多死的人，谁来算？我宁可当坏人，也不要再赌别人的命。」',
  's.ch4.s2.rB.after': '你忽然读懂那半秒的犹豫：凛不是不信你，是不敢再信自己。她把每一条死亡都扛成自己的账，于是抢先把自己变成怪物——这样输的那一天，就只需要恨一个人。',
  's.ch4.s2.rC': '你借着浓雾翻身退入林间。她没有追——猎人，从不浪费子弹。',
  's.ch4.s2.rC.rin': '雾里，凛对着你消失的方向低声开口，轻得几乎只说给自己听：「跑吧。多活一晚，是一晚。等你想通了，再回来找我算账。」',
  's.ch4.s2.rC.after': '那句低语，你其实听见了。你没有回头——但你记住了：凛放你走，不是慈悲，而是一场赌注。她在等你带回一个连她自己都还不敢相信的答案。雾在身后合拢，你加快脚步，把那份沉重一起带进了夜里。',
  's.ch4.s3.rin': '「别误会，我不是在救你。我只是还没决定，要把最后一发留给谁。」她退进阴影，枪口始终没有放下。',
  's.ch4.s3.cA': '朝她喊：「你不必一个人扛。」',
  's.ch4.s3.cB': '沉默，把她留下的破绽记在心底。',
  's.ch4.s3.cC': '不放下武器，戒备她的犹豫。',
  's.ch4.s3.rA': '你朝那道正退入雾中的背影喊了一句。话一出口，雾里的脚步声，停了半拍。',
  's.ch4.s3.rA.rin': '「……多管闲事。」凛的声音从雾里飘回来，比方才软了一线，「但——谢谢你，没朝我的背影开枪。」',
  's.ch4.s3.rB': '你没有出声，只把她话里那道裂缝，悄悄收进心底，留待还用得上的那一天。',
  's.ch4.s3.rB.rin': '「不说话？也好。」雾里的声音听不出情绪，「会闭嘴的人，往往比会开枪的人，活得久一点。」',
  's.ch4.s3.rC': '你没有放下武器，目光追着雾里每一丝晃动——她的犹豫是真的，但这座岛，从不为犹豫的人留活路。',
  's.ch4.s3.rC.rin': '「聪明。」雾里传来一声极轻的气音，分不清是赞许还是嘲弄，「别把这份警觉，在走到我面前之前就用完了。」',
  's.ch4.s3.1': '无论你的选择是什么，凛都不会是最后一个挡在你面前的人。求生，仍在继续。',
  's.ch4.s3.2': '你终于听懂她话里的裂缝——连最冷的人，也在替自己寻找一个不必扣下扳机的理由。',
  's.ch4.s3.end': '凛的身影融进阴影，留你独自面对下一个转角。远处枪声此起彼落——这座岛不会等任何人想通，下一场厮杀，已经在等你了。',

  // 第五章
  's.ch5.s1.scene': '破晓前最深的暗里，你们缩在港口仓库的角落。潮水拍打防波堤，一下一下，像在替所剩无几的人数计时。远处灯塔仍尽责地转着，那道光却照不进任何人的眼睛。',
  's.ch5.s1.voice': '【广播】特别通知。存活人数逼近个位数。主办方谨此提醒：当幸存者剩余三人，解除码将下发至各位项圈。优胜近在咫尺——只要你愿意，亲手送走身边最后几个人。',
  's.ch5.s1.kaede': '「我看懂了。」枫的声音发颤，「项圈的解除码，会在『最后三人』时送进每个人的项圈——这是给优胜者的钥匙。但只要有人愿意当诱饵……我们能把它整串导出来。」',
  's.ch5.s1.1': '导出，意味着有人得故意走进射程，把自己当成讯号的中继。成功，所有人得救；失败，那人当场引爆。',
  's.ch5.s1.mid': '一条命，换所有人的明天——这道算式听起来太划算，划算到让人作呕。你终于看清项圈真正的恶意：它不只锁住脖子，更逼着每个人，学会把「谁该去死」算成一笔账。',
  's.ch5.s1.hikari': '「那……时间，让我来数吧。」一直没出声的ひかり轻轻举起手，声音细却稳：「我跑不快，也不会打架。可是只要有人盯着秒数、有人记得你们几点该回来——你们就不会只是一串会归零的数字。这个，我做得到。」',
  's.ch5.s1.after': '你看着那双不会打架的手，认真地比出一个「开始计时」的手势。在这座把人逼成数字的岛上，她偏偏选择去守护「时间」本身——好让每个归来的人，都还记得自己是谁。你忽然觉得，这场仗，也许真的值得打。',
  's.ch5.s2.q': '枫看着你。这一次，没有人能替你决定。你——',
  's.ch5.s2.cA': '自愿当诱饵',
  's.ch5.s2.cB': '另寻不必牺牲的办法',
  's.ch5.s2.rA': '「我去。」你听见自己这么说。樱想拦，却被你轻轻推开——有些路，只能一个人走。',
  's.ch5.s2.rA.sakura': '「你最好给我活着回来。」さくら的眼眶红了，却硬是把泪逼回去，「我不准任何人替我『牺牲』——你只是先过去，然后等我们追上。听懂没有？」',
  's.ch5.s2.rA.after': '你笑着点头，把那句「如果回不来」咽了回去。中继点的坐标在掌心发烫，你忽然懂了凛当初的心情——把最危险的位置留给自己，不是勇敢，只是再也受不了，眼睁睁看着别人替你去死。',
  's.ch5.s2.rB': '「一定还有别的办法。」你不肯认命。枫苦笑。',
  's.ch5.s2.rB.kaede': '「但愿这座岛，给得起我们时间。」',
  's.ch5.s2.rB.sakura': '「时间不够，我们就自己挤出来。」さくら攥紧了拳，声音不大，却像钉子一样牢：「我不要任何人被当成代价——这一次，连『牺牲』两个字，都不准它出现。」',
  's.ch5.s2.rB.after': '没有人出声附和，却也没有人别开眼。枫低下头，把计划又算了一遍——这一次，她把「来不及」三个字，从纸上划掉了。你明白那不是把握，只是一群人决定不再向时间低头，哪怕时间，从来就不站在你们这边。',
  's.ch5.s2.cC': '提议轮流分摊，没有人独自送死',
  's.ch5.s2.rC': '「要冒险，就一起冒。」你说，「中继轮着当，谁撑不住就换人——把『一个人去死』改成『所有人一起活下来』。」',
  's.ch5.s2.rC.kaede': '枫怔了一下，随即用力点头，眼里有光：「……对。我怎么没想到。把风险拆开，数学就不一样了。我重算路径——这次，算进每一个人。」',
  's.ch5.s2.rC.after': '没有人需要当英雄，也没有人被准许独自赴死。这念头简单得近乎天真，简单到这座岛从没打算让你们想到——它要的是一个幸存者，你们偏要塞给它一整群活人。',
  's.ch5.s3.1': '计划进入最后阶段。当第一缕天光刺破海平面，这座岛的游戏，也将迎来终局。',
  's.ch5.s3.kaede': '枫锁死最后一段代码，别过脸不敢看你：「中继的坐标……是我算的。要是出了差错，是我害的。」她深吸一口气，逼自己抬眼，「所以你一定要回来——给我一个说对不起、也说谢谢的机会。」',
  's.ch5.s3.hikari': '「我会数着时间，等你回来。」ひかり的声音很轻，却把每个字都压得很稳，「所以——一定要回来哦。」',
  's.ch5.s3.cA': '对枫说：坐标我信，回不来也不是你的错。',
  's.ch5.s3.cB': '对ひかり笑：数到我回来为止，一秒都别少。',
  's.ch5.s3.cC': '什么都不说，只把武器再检查一遍。',
  's.ch5.s3.rA': '你按住枫那只还在发抖的手，把每个字都说得很慢。',
  's.ch5.s3.rA.kaede': '枫的眼眶一下子红了，却倔强地不让泪落下：「……回来再说这些。我把『对不起』和『谢谢』，都记在你回来的那一刻。」',
  's.ch5.s3.rB': '你朝ひかり比了个「拜托了」的手势，扯出一个尽量轻松的笑。',
  's.ch5.s3.rB.hikari': '「嗯！」ひかり用力点头，把码表按在胸口，「我会数得很大声——大声到你在再远的地方，都听得见回家的拍子。」',
  's.ch5.s3.rC': '你没有多话，只是把武器的每一处再确认一遍——弹匣、扣带、握感。沉默，有时比承诺更接近认真。',
  's.ch5.s3.rC.hikari': 'ひかり看着你的背影，没有催，只把计时的拇指轻轻搭上按钮：「……我懂。话留着，回来再说。」',
  's.ch5.s3.end': 'ひかり的话像一枚压在掌心的暖石。你最后看了眼那道将亮未亮的天光，转身走进尚未散去的夜——这一回，你不只是为了活着，而是为了回得来。',

  // 终章
  's.ch6.s1.scene': '第一道灰白的光从海平线渗开，整座岛浸在一种不真实的安静里——仿佛连这场游戏，也屏住了呼吸。草叶上凝着夜露，颈间的项圈依旧冰冷，提醒你昨夜并非一场梦。',
  's.ch6.s1.1': '岛上只剩寥寥数人。枪声稀了，海浪声反而清晰起来。天，要亮了。',
  's.ch6.s1.voice': '【广播】各位同学，最后通报。存活——三。恭喜你们走到这里。距离『优胜者』，只剩两个名字的距离。',
  's.ch6.s1.2': '你站在灯塔下，手里握着用无数人的命换来的选择。最后一步，由你决定。',
  's.ch6.s1.mid': '海风里，那些再也走不到黎明的脸一张张浮现——有人替你挡过刀，有人到最后仍喊着你的名字。你忽然明白：接下来这一步，从来不只是为了自己活着，而是为了让他们的「活过」，不被这座岛轻易抹去。',
  's.ch6.s1b.1': '你在心里，一个一个喊了他们的名字。没有名单，没有编号——只有你记得的、笑过哭过的同学。',
  's.ch6.s1b.sakura': '「不管你选哪条路，」さくら不知何时站到你身旁，声音很轻却很稳，「我都陪你走完。我们答应过彼此的——谁都不准，一个人扛。」',
  's.ch6.s1b.kaede': '「能拆的后门，我都留给你了。」枫不知何时也到了，肩上还挂着那台改了又改的信号机：「剩下的——换你来写结局。我们负责，盯着你把它写完。」',
  's.ch6.s1b.hikari': '「时间……我一直数着呢。」ひかり轻声开口，指尖在掌心一下、一下地点着，像替谁守着节拍：「你回来的时刻，我会记得。所以——一定要回来，让我数到你。」',
  's.ch6.s1b.absent': '海风捎来咸涩的气味。她们之中，有人没能一起走到这里——那份重量没有人说出口，却谁都记得。',
  's.ch6.s1b.2': '灯塔的光扫过海面，像在替这座岛，数最后一次倒数。是时候了。',
  's.ch6.s2.q': '三条路在眼前展开——每一条，都要拿某样东西去换。你深吸一口气，做出最后的选择——',
  's.ch6.s2.cA': '成为最后的幸存者',
  's.ch6.s2.cB': '带着钥匙，逃离孤岛',
  's.ch6.s2.cC': '掀翻这张桌子，反抗到底',
  's.ch6.e1.1': '你撑到了最后。当直升机的轰鸣盖过海浪，你成了名单上唯一的名字。',
  's.ch6.e1.2': '他们替你戴上「优胜者」的头衔。可你知道，活下来的人，从此再也睡不安稳。',
  's.ch6.e2.1': '解除码生效，项圈一个接一个松脱、落地。你带着还活着的人，奔向港口那艘船。',
  's.ch6.e2.2': '引擎发动，孤岛在身后缩成一个黑点。自由的滋味，咸得像泪。',
  's.ch6.e3.1': '你没有逃，也没有独活。你举起枫改造过的讯号，对准了监督教官的本部。',
  's.ch6.e3.officer': '本部的喇叭里，监督教官的声音第一次起了波澜：「你以为按下那个键，就能改变什么？这游戏我们办过几十届，每一届都有人这么想——」话没说完，便被你的讯号盖了过去。',
  's.ch6.e3.2': '「这场游戏，该结束了。」萤幕全暗的那一刻，你不知道前方是什么——但至少，不再是他们写好的剧本。',
  's.ch6.e1.3': '「对不起……也谢谢你们，把活下去的份，一起交给了我。」她对着空无一人的海，轻声说。',
  's.ch6.e1.end': '直升机升空，岛屿在脚下缩成一块褪色的疤。你赢了这场游戏——可从今往后，每一个安稳的夜里，都会有人在你梦中轻轻喊你的名字。',
  's.ch6.e2.3': '「我设计的信号，本来只是想让谁活着看到明天。能看到的人是你们——这样就够了。」',
  's.ch6.e2.end': '甲板上没有人欢呼。幸存的人挤在船舷，望着那座吞掉许多名字的岛，一点点沉进晨雾里。你知道有些人永远留在了那里——而你们能做的，是替他们把今后的每一个明天，都好好活着。',
  's.ch6.e3.3': '「就算这只是另一个更大的牢笼，我也要亲手敲开第一道门。」她没有回头。',
  's.ch6.e3.end': '本部的屏幕一块块熄灭，倒数归零，广播第一次安静了下来。没有直升机，没有船，前方只有未知——但这一次，翻开下一页的手，是你们自己的。剧本被撕了，故事才正要由活下来的人，重新写起。',
  's.ch6.complete': '—— 你的故事，在此暂告一段落。',
}

export default zhCN
